export const GRAPH_RESOURCES_REDUCER_KEYS = {
  BY_ID: 'byId',
  BY_TEXT: 'byText',
  BY_USER: 'byUser',
  ENABLED: 'ENABLED',
  REDUCER: 'graphResources',
}
